var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showInformacoesAnalise
        ? _c("informacoes-analise", {
            attrs: {
              responsavel: _vm.cadastro.usuario.pessoa.nomeRazaoSocial,
              data: _vm.cadastro.dataFinalizacao,
              cargo: _vm.cadastro.perfil.nome
            }
          })
        : _vm._e(),
      !_vm.isRetificacao
        ? _c("divider", { attrs: { label: "Peças Técnicas" } })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "mt-1" },
        [
          !_vm.isRetificacao
            ? _c("appMapa", {
                ref: "mapa",
                attrs: {
                  idMapa: "mapaArrecadacaoGeo",
                  height: "65vh",
                  mapLayersConfigs: _vm.layers,
                  buttons: _vm.buttonsConfig,
                  featureLayerConfig: _vm.featureLayerConfig
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mt-1" },
        [
          !_vm.isRetificacao
            ? _c("informacoes-area-arrecadacao", {
                attrs: {
                  area: _vm.area,
                  perimetro: _vm.perimetro,
                  municipios: _vm.municipios
                }
              })
            : _vm._e(),
          _vm.documentosAutenticavel
            ? _c(
                "div",
                [
                  _c("app-visualizar-documentos", {
                    attrs: { dadosCadastros: _vm.getDocumentosAutenticaveis() }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.documentosCadastro
            ? _c(
                "div",
                [
                  _c("app-visualizar-documentos", {
                    attrs: { dadosCadastros: _vm.getDocumentos() },
                    on: { setValidacaoDocumentos: _vm.setValidacaoDocumentos }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c52eb79", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c52eb79","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/components/VisualizarCadastroColetivo.vue
// module id = null
// module chunks = 